import React from "react";

import ProductPageTemplate from "../../components/global/layout/ProductPageTemplate";
import { gaSheet } from "../../constants/productPageData";

const GASheetPage = ({ location }) => {
    return (
        <ProductPageTemplate
            page={gaSheet}
            theme="green"
            location={location}
        />
    )
}

export default GASheetPage